import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { canopy } from "./../theme";

export const HouseIcon = ({ size = 38 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={canopy.green}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 10.5 12 3l9 7.5"></path>
    <path d="M5 9.5V21h14V9.5"></path>
    <path d="M9 21v-6h6v6"></path>
  </svg>
);

// Shared Canopy chrome for the public screens (sign in / sign up / reset / unauthorized)
export default function AuthLayout({ subtitle, children }) {
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <Box
        sx={{
          bgcolor: canopy.soft,
          borderRadius: "0 0 28px 28px",
          pt: 8,
          pb: 5,
          px: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: "24px",
            bgcolor: "background.paper",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 8px rgba(37, 51, 40, 0.08)",
          }}
        >
          <HouseIcon />
        </Box>
        <Stack alignItems="center" spacing={0.5}>
          <Typography variant="h5" sx={{ color: canopy.greenDark }}>
            Shelby Estates
          </Typography>
          {subtitle && (
            <Typography sx={{ color: canopy.inkSoft, fontWeight: 600 }}>
              {subtitle}
            </Typography>
          )}
        </Stack>
      </Box>
      <Container component="main" maxWidth="xs">
        {children}
      </Container>
    </Box>
  );
}
